/**
 * kult-grind.js — Mahlgrad-Optionen B2C (10.10.2026, Philip), Gegenstück zu snippets/kult-grind.liquid.
 * Zur Wahl stehen nur Ganze Bohne, Filter (= Variante „Handfilter“), French Press und Espressokocher (= „Herdkanne“).
 * Siebträger/Vollautomat (SKU-Suffix ST/VA) bleiben als Varianten bestehen (Seal-Verträge, SKUs) und werden
 * ausgeblendet; wer Siebträger oder Vollautomat als Zubereitung wählt, bekommt „Ganze Bohne“.
 * Geladen früh im <head> über snippets/kult-customer-prefs.liquid (defer, vor allen Section-Skripten).
 *
 * window.KultGrind
 *   forMethod(method) → Variantenwert zur Zubereitungsart ('Handfilter' | 'French Press' | 'Herdkanne' | 'Ganze Bohne'), '' wenn unbekannt
 *   hidden(value)     → true für Siebträger/Vollautomat (auch Variantentitel „250 g / Siebträger“)
 *   visible(value)    → wählbarer Variantenwert (Siebträger/Vollautomat → 'Ganze Bohne')
 *   label(value)      → Anzeige ('Handfilter' → 'Filter', 'Herdkanne' → 'Espressokocher'), auch im Variantentitel
 *   BEAN              → 'Ganze Bohne'
 * window.kultGrindForMethod = KultGrind.forMethod
 */
(function () {
  'use strict';
  if (window.KultGrind) return;
  var BEAN = 'Ganze Bohne';
  var BY_METHOD = {
    handfilter: 'Handfilter', filtermaschine: 'Handfilter', filter: 'Handfilter',
    frenchpress: 'French Press', herdkanne: 'Herdkanne',
    siebtraeger: BEAN, vollautomat: BEAN, bohne: BEAN
  };
  function hidden(value) {
    var d = String(value || '').toLowerCase();
    return d.indexOf('sieb') > -1 || d.indexOf('vollautomat') > -1;
  }
  function visible(value) { return hidden(value) ? BEAN : String(value || ''); }
  function label(value) { return String(value || '').replace('Handfilter', 'Filter').replace('Herdkanne', 'Espressokocher'); }
  function forMethod(method) { return BY_METHOD[String(method || '').toLowerCase().trim()] || ''; }
  window.KultGrind = { BEAN: BEAN, forMethod: forMethod, hidden: hidden, visible: visible, label: label };
  window.kultGrindForMethod = forMethod;
})();
